function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "2.2a\\u2013-System-Admin-\\u2013-Images-\\u2013-Folders-tab-moving",
  transform: "translate(-97.000000, -495.000000)"
}, React.createElement("g", {
  id: "open-folder",
  transform: "translate(97.000000, 495.000000)"
}, React.createElement("g", {
  id: "folder-copy",
  fill: "#8B8B8B",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M12.590399,2.48470911 L9.03678304,2.48470911 C8.17331671,2.48470911 7.46882793,1.77301703 7.46882793,0.893681917 C7.46882793,0.656451222 7.28179551,0.466666667 7.04800499,0.466666667 L2.409601,0.466666667 C1.08167082,0.466666667 0,1.56425401 0,2.91172436 L0,11.0882756 C0,12.435746 1.08167082,13.5333333 2.409601,13.5333333 L12.590399,13.5333333 C13.9183292,13.5333333 15,12.435746 15,11.0882756 L15,4.92660373 C15,3.57913338 13.9183292,2.48470911 12.590399,2.48470911 Z M14.1583541,11.0851126 C14.1583541,11.9612846 13.4569825,12.6761398 12.590399,12.6761398 L2.409601,12.6761398 C1.54613466,12.6761398 0.841645885,11.9644477 0.841645885,11.0851126 L0.841645885,2.91172436 C0.841645885,2.03555233 1.54301746,1.32069717 2.409601,1.32069717 L6.66458853,1.32069717 C6.86408978,2.46573065 7.85224439,3.33873961 9.03678304,3.33873961 L12.590399,3.33873961 C13.4538653,3.33873961 14.1583541,4.0504317 14.1583541,4.9297668 L14.1583541,11.0851126 L14.1583541,11.0851126 Z",
  id: "Shape"
})), React.createElement("path", {
  d: "M5.62155028,5 L16.8848149,5 C17.4370996,5 17.8848149,5.44771525 17.8848149,6 C17.8848149,6.19122961 17.829984,6.37844954 17.7268221,6.53946625 L14.1777372,12.0789325 C13.8100277,12.6528591 13.1753399,13 12.4937228,13 L3.2136671,13 C2.1090976,13 1.2136671,12.1045695 1.2136671,11 C1.2136671,10.636529 1.31271752,10.2799293 1.50017287,9.96852652 L3.90805606,5.96852652 C4.26984207,5.36752392 4.92005671,5 5.62155028,5 Z",
  id: "Rectangle",
  stroke: "#8B8B8B",
  fill: "#D8D8D8"
}))));

const SvgOpenfolder = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "19px",
    height: "14px",
    viewBox: "0 0 19 14",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgOpenfolder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/open folder.1168eb3d.svg";
export { ForwardRef as ReactComponent };